import React, {useEffect, useState} from "react";

const FormCampoTAREA = ({label, valor, setValor, isRequerido = false, displayType = 'h', isShort = false}) => {
  const [isValid, setIsValid] = useState(true);
  
  const cssLabel = isValid ? "label has-text-right label170" : "label has-text-right has-text-danger label170";
  const iconRequerido = isRequerido ? "* " : " "
  
  useEffect(() => {
    if (isRequerido) {
      setIsValid(!!valor);
    } else {
      setIsValid(true);
    }
    
  }, [isRequerido, valor])
  
  
  let labelElement = null;
  let cssController = 'field is-horizontal';
  
  if (displayType === "h") {
    labelElement = (
      <div className="field-label is-normal">
        <label className={cssLabel}>
          {label} {iconRequerido}
        </label>
      </div>
    );
  } else if (displayType === "v") {
    cssController = ''
    const cssLabelV = isValid ? "" : "has-text-danger";
    labelElement = (
      <div className={cssLabelV}>
        {label} {iconRequerido}
      </div>
    );
  }
  
  const css = isShort ? "textarea short" : "textarea"
  
  return (
    <div className={cssController}>
      {labelElement}
      <div className="field-body">
        <div className="field">
          <div className="control">
              <textarea className={css}
                        value={valor || ""}

                        onChange={event => setValor(event.target.value)}
              />
          </div>
        </div>
      </div>
    </div>
  
  );
};

export default FormCampoTAREA